<template>
  <Button
    :size="size"
    :type="colorType"
    :icon="iconType"
    @click="handleClick"
    :disabled="isDisabled">
    {{ languageText}}
  </Button>
</template>

<script>
  export default {
    name: 'basicButton',
    props: {
      btnType: {
        type: String
      },
      text: {
        type: String
      },
      icon: {
        type: String
      },
      styleType: {
        type: String,
        default: 'default'
      },
      size: {
        type: String,
        default: 'small'
      }
    },
    data () {
      return {
        languageText: '',
        colorType: this.styleType,
        iconType: '',
        isDisabled : false,
      }
    },
    mounted () {
      switch (this.btnType) {
        case 'Search':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.search')
          this.colorType = 'primary'
          this.iconType = this.icon !== undefined ? this.icon : 'search'
          break
        case 'Reset':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.reset')
          this.colorType = 'primary'
          this.iconType = this.icon !== undefined ? this.icon : 'refresh'
          break
        case 'Add':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.add')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'plus'
          break
        case 'Edit':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.edit')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'edit'
          break
        case 'Delete':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.delete')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'trash-b'
          break
        //
        case 'Export':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.export')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'ios-download'
          break
        case 'TemDownload':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.temDownload')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'upload'
          break
        case 'Import':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.import')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'ios-upload'
          break
        case 'Enable':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.enable')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'unlocked'
          break
        case 'Disable':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.disable')
          this.colorType = 'error'
          this.iconType = this.icon !== undefined ? this.icon : 'locked'
          break
        case 'Detail':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.detail')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'information-circled'
          break
        case 'View':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.view')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'eye'
          break
        case 'Print':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.print')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'printer'
          break
        case 'Upload':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.upload')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'upload'
          break
        case 'Submit':
          this.languageText = this.text !== undefined ? this.text : this.$t('global.button.submit')
          this.colorType = this.styleType
          this.iconType = this.icon !== undefined ? this.icon : 'checkmark'
          break
        default:
          this.languageText = this.text
          this.iconType = this.icon
          this.colorType = this.styleType
          break
      }
    },
    methods: {
      handleClick (event) {
        this.$emit('click', event)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BasicButton.vue?42310aa9